import { createContext, useContext } from 'react';
import { SemanticTokenBasedTheme } from '@woodmac-hycb/theme-default';

export type HostThemeName = SemanticTokenBasedTheme;

export interface HostThemeContextValue {
    themeName: HostThemeName;
    setThemeName: (name: HostThemeName) => void;
}

export const HostThemeContext = createContext<HostThemeContextValue>({
    themeName: SemanticTokenBasedTheme.Woodmac,
    setThemeName: () => {},
});

export const useHostTheme = (): HostThemeContextValue =>
    useContext(HostThemeContext);

export const isKnownTheme = (name: unknown): name is HostThemeName =>
    (Object.values(SemanticTokenBasedTheme) as unknown[]).includes(name);

export const THEMES: { name: HostThemeName; label: string }[] = [
    { name: SemanticTokenBasedTheme.Woodmac, label: 'Woodmac' },
    { name: SemanticTokenBasedTheme.Lens, label: 'Lens (legacy)' },
    { name: SemanticTokenBasedTheme.DsTestMode, label: 'DS Test (debug)' },
];
